// GSAP -------------------------------------------------------------
import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import ScrollTrigger from 'gsap/ScrollTrigger'
import DrawSVGPlugin from 'gsap/DrawSVGPlugin'
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger, DrawSVGPlugin);
window.ScrollTrigger = ScrollTrigger;
window.gsap = gsap;

// PARALLAX EFFECT
if ($('.image-scroll-move').length) {
    $('.image-scroll-move').each(function () {
        let image = $(this).find('img');
        let wrapper = $(this);

        let loadedImage = document.createElement('img');
        loadedImage.src = image.attr('src');

        loadedImage.onload = function () {
            image.height(image.height() * 1.25);

            gsap.to(image, {
                scrollTrigger: {
                    trigger: wrapper,
                    start: 'top-=25% center',
                    end: 'bottom+=25% center',
                    scrub: 1.5,
                },
                y: -(image.height() * 0.2),
            });
        }
    })
}
// HOMEPAGE - PRODUCT FIELD
// ------------------------------------------------------------------
if ($('.homepage-product-field').length) {
    if (windowWidth > 991) {
        let homepageProductField = $('.homepage-product-field .container .wrapper .right-field .product-box-field .product-boxes');
        let homepageProductBoxOdd = $('.homepage-product-field .container .wrapper .right-field .product-box-field .product-boxes .product-mini-box:nth-child(odd)');
        let homepageProductBoxEven = $('.homepage-product-field .container .wrapper .right-field .product-box-field .product-boxes .product-mini-box:nth-child(even)');

        let solutionsTL = gsap.timeline({
            scrollTrigger: {
                trigger: homepageProductField,
                start: 'top-=50% center',
                end: 'bottom+=50% center',
                scrub: 1.5,
            }
        })

        solutionsTL.to(homepageProductBoxOdd, { y: '-15%' }, 'same')
        solutionsTL.to(homepageProductBoxEven, { y: '15%' }, 'same')
    }
}

// PRELOADER ANIMATION
// ------------------------------------------------------------------
if ($('.preloader').length) {
    let preloaderIMGOne = $('.preloader .preloader-inner .image-field .preloader-one')
    let preloaderIMGTwo = $('.preloader .preloader-inner .image-field .preloader-two')

    gsap.to(preloaderIMGOne, { rotation: 90, duration: .5, delay: 0 });
    gsap.to(preloaderIMGOne, { rotation: 180, duration: .5, delay: 1 });
    gsap.to(preloaderIMGOne, { rotation: 270, duration: .5, delay: 2 });
    gsap.to(preloaderIMGOne, { rotation: 360, duration: .5, delay: 3 });
    gsap.to(preloaderIMGTwo, { scale: 1, duration: 1, delay: 3 });
}

// HOMEPAGE - ABOUT FIELD
// ------------------------------------------------------------------
if ($('.homepage-about-field').length) {
    let homepageAboutMask = gsap.timeline({
        y: 200,
    })
    gsap.to(".homepage-about-field .background-mask", {
        scrollTrigger: {
            trigger: $('.homepage-about-field'),
            start: 'top-=50% center',
            end: 'bottom+=50% center',
            scrub: 1.5,
        },
        x: 150
    });
}

// SAMPLE USAGE
// ------------------------------------------------------------------
// if ($('.sample').length) { }